/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandMercedes = createReactComponent("brand-mercedes", "IconBrandMercedes", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 3v9", key: "svg-1" }],
  ["path", { d: "M12 12l7 5", key: "svg-2" }],
  ["path", { d: "M12 12l-7 5", key: "svg-3" }]
]);

export { IconBrandMercedes as default };
//# sourceMappingURL=IconBrandMercedes.js.map
